import { Configuration, OrdersApi } from '@/api';
import { OrderAssociation } from '@/models/Order';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const defaultInclude: OrderAssociation[] = [OrderAssociation.SUPPLIER, OrderAssociation.STORE];

const useGetOrderQuery = (orderId?: string, include: OrderAssociation[] = defaultInclude) => {
  const queryClient = useQueryClient();
  const auth = useAuth();
  const ordersApi = new OrdersApi(new Configuration(auth));

  const queryKey = ['order', orderId] as const;

  const {
    data: order,
    isLoading,
    isFetching,
    error,
  } = useQuery({
    queryKey,
    queryFn: () => {
      if (!orderId) throw new Error('Missing orderId');
      return ordersApi.getOrder(orderId, include);
    },
    enabled: Boolean(orderId),
  });

  const invalidateQuery = async () => {
    return queryClient.invalidateQueries({ queryKey });
  };

  return {
    order,
    isLoading,
    isFetching,
    error,
    invalidateQuery,
  };
};

export default useGetOrderQuery;
